import { Trans } from '@lingui/react/macro';

import Notification from '@/components/Notification';
import { Link } from '@/components/typography';
import { ROUTES } from '@/router';

const TagNotFoundNotification = () => {
  return (
    <Notification type="error" size="large">
      <Trans>
        Uh oh! C99 Tag has not been found on your website. Please place the C99 Tag{' '}
        <Link variant="caption1" color="static-white" to={ROUTES.companySettingsGeneral.path}>
          FOUND HERE
        </Link>{' '}
        or make this request to your admin.
      </Trans>
    </Notification>
  );
};

export default TagNotFoundNotification;
